// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "patientDashboard." + ({"138":"profile","147":"app-routes","251":"checkout","352":"onboarding"}[chunkId] || chunkId) + "." + {"138":"093379d5d97951ceb198","147":"f52b352c761d5c4a436f","251":"4a2bc5274e7c330a1b90","352":"510f240093e4ebca815a","544":"da2e9679d2efe0ea37eb"}[chunkId] + ".js";
};